import moment from 'moment';

const isValidDay = (value) => {
  const date = moment(value, 'DD/MM/YYYY', true);
  return date.isValid() ? date.year() >= 1000 : false;
};

export default isValidDay;


// case CLIENT_DETAILS.DATE_OF_BIRTH:

//     return yup.object().shape({
//       [CLIENT_DETAILS.DATE_OF_BIRTH]: yup
//         .string()
//         .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientDetails.dob' }) }))
//         .test(
//           intl.formatMessage({ id: 'validation.invalidDateFormat' }),
//           intl.formatMessage({ id: 'validation.invalidDateFormat' }),
//           (value) => {
//             if (isValidDay(value)) return true;
//             return false;
//           },
//         ),
//       //   ADD MORE DATE FORMAT RULES
//     });
